/**
 * Wallet store — Storm Crystals balance from the cross-game portal.
 * AIWARI fetches via /aiwari-api/wallet/:stormId; the realm server reads
 * Supabase `wallets` table by user_id. Refreshes on World mount + on
 * dungeon clear + every 60s while online.
 */

import { create } from 'zustand';

interface WalletStore {
  crystals: number;
  loading: boolean;
  lastFetched: number;
  setCrystals: (n: number) => void;
  setLoading: (b: boolean) => void;
}

export const useWallet = create<WalletStore>((set) => ({
  crystals: 0,
  loading: false,
  lastFetched: 0,
  setCrystals: (n) => set({ crystals: n, lastFetched: Date.now() }),
  setLoading: (b) => set({ loading: b }),
}));
